import styled from 'styled-components';
import ArrowRight from '../../assets/images/arrow-white.svg';
import { breakpointDown } from 'styles/breakpoints';

export const HomeIntroPanelStyle = styled.div`
    padding: 60px 0 45px;

    h1 {
        font-family: 'PhoenixSansMediumWeb';
        font-size: ${({ theme }) => theme.fontSizes[10]}; // 36px
        line-height: 42px;
        margin-top: 0;
    }
    .mid-life {
        &__intro {
            line-height: 28px !important;
            font-size: ${({ theme }) => theme.fontSizes[8]}!important; // 24px
            padding-bottom: ${({ theme }) => theme.fontSizes[8]};
        }

        &__btn {
            /* margin-top: 60px; */
            display: block;
            background-color: ${({ theme }) => theme.colors.aubergine};
            color: ${({ theme }) => theme.colors.white};
            text-decoration: none;
            margin-left: 0;
            font-family: 'PhoenixSansMediumWeb';
            border-radius: 4px;
            font-size: 20px;
            max-width: 400px;
            height: 48px;
            padding: 0 27px;
            display: flex;
            align-items: center;
            gap: 100px;
            transition: border-bottom-right-radius 180ms ease-in-out;

            ${breakpointDown.md`
                 margin-top: 20px;
            `};

            ${breakpointDown.xs`
                 justify-content: space-between;
                 gap: 0;
            `};

            &:hover {
                border-bottom-right-radius: 22px;
            }

            &:after {
                content: '';
                // prettier-ignore
                background: url("${ArrowRight}") no-repeat center center;
                height: 45px;
                width: 45px;
            }
        }

        &__button-box {
            margin-top: 30px;
            padding: 18px;
            border-radius: 2px;
            border: 1px solid ${({ theme }) => theme.colors.lightgrey};

            h4 {
                margin: 0;
                font-size: ${({ theme }) => theme.fontSizes[7]}; // 36px
                ${breakpointDown.md`
                    font-size: ${({ theme }) => theme.fontSizes[6]};
                `};
                ${breakpointDown.sm`
                    font-size: ${({ theme }) => theme.fontSizes[5]};
                `};
            }
            > div {
                align-items: center;
            }
            .mid-life__btn {
                span {
                    width: 100%;
                }
            }
        }
    }
    p {
        line-height: 1.5;
    }
`;
